import { Link as RouterLink } from 'react-router-dom'
import Chip from '@mui/material/Chip'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import { useTeam } from '../../contexts/TeamContext'
import { usePackageImports } from '../../contexts/PackageImportsContext'

function ServiceManagedByChip({ service, project }) {
  const { team } = useTeam()
  const { packageImportsById } = usePackageImports()

  // Only show for services managed by package imports
  if (!service.managed || service.managedBy?.type !== 'Marketplace::PackageImport') {
    return null
  }

  const packageImport = packageImportsById[service.managedBy.id]
  if (!packageImport) return null

  const packageName = packageImport.package?.name || 'Package'
  const packageImportUrl = `/teams/${team.slug}/docker/projects/${project.slug}/packages/${packageImport.id}/edit`

  return (
    <Chip
      icon={<Inventory2OutlinedIcon />}
      label={packageName}
      size="small"
      color="info"
      clickable
      component={RouterLink}
      to={packageImportUrl}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    />
  )
}

export default ServiceManagedByChip
